import React, { memo, useCallback } from "react";
import UserTagGroupSelector, {
  Option,
} from "modules/selectors/user-tag-group-selector";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { useAuth } from "modules/providers/auth-provider";

interface IProps {
  draftId: string;
}

const ComposeTaskAssigneeSelector = ({ draftId }: IProps) => {
  const { me } = useAuth();
  const { draft, setTask } = useMessageThreadDraft({
    draftId,
  });

  const onSelectedOptionsChanged = useCallback(
    (option: Option[]) => {
      if (option.length !== 1) {
        return;
      }
      if (!draft || !draft.task) {
        return;
      }
      setTask({
        ...draft.task,
        assignedUserId: option[0].id,
      });
    },
    [draft, setTask],
  );

  const assignedUserIdOption: Option[] | undefined = draft?.task?.assignedUserId
    ? [
        {
          id: draft.task.assignedUserId,
          active: true,
          type: "user",
        },
      ]
    : undefined;

  if (!draft || !me) return null;

  return (
    <UserTagGroupSelector
      isMultiSelect={false}
      onSelectedOptionsChanged={onSelectedOptionsChanged}
      types={["user"]}
      defaultValues={assignedUserIdOption}
      value={assignedUserIdOption}
      placeHolder="Select Assigned To"
      firstIds={[me.id]}
      allowInactive={false}
    />
  );
};

export default memo(ComposeTaskAssigneeSelector);
